import Button from './elements/Button';
import data from '../data/products.json';
import React, { Dispatch, SetStateAction } from 'react';

function ProductsSelection({selectedProduct, setSelectedProduct} : {selectedProduct: Product|null, setSelectedProduct:Dispatch<SetStateAction<Product|null>>}) {

    const products = (data as Product[]).map((product) => {

        const details = product.details.map((it, index) => <li key={index}>{it}</li>)
        const selectedCss = selectedProduct?.id === product.id ? 'border-2 border-cyan-600' : ''

        return (
            <div key={product.id} className={selectedCss + ' flex bg-white p-4 flex-row my-8 rounded-lg'}>
                <div>
                    <div className={'overflow-hidden rounded-lg h-56 w-96'}>
                        <img className={'w-96'} src={require('../data/img/' + product.image)} alt={product.name} />
                    </div>
                    <div className={'mt-5'}>
                        <Button onClick={() => setSelectedProduct(product)} text={'Choose product'} full={true}></Button>
                    </div>
                </div>
                <div className={'px-6 pb-2'}>
                    <h2 className={'text-2xl tracking-tight text-gray-900'}>{product.name}</h2>
                    <h3 className={'mt-4 text-sm text-gray-800'}>Description</h3>
                    <p className={'mt-4 text-sm text-gray-600'}>{product.description}</p>
                    <h3 className={'mt-6 text-sm text-gray-800'}>Details</h3>
                    <ul className={'list-disc mx-6 mt-4 text-sm text-gray-600'}>
                        {details}
                    </ul>
                </div>
            </div>
        );
    });

    return <div className={'px-10 py-10 bg-gray-50 h-screen overflow-scroll'}>
        {products}
    </div>;
}

export enum ProductCategory {
    SOLAR = "SOLAR",
    TILE = "TILE"
}

export interface Product {
    id: number
    name: string
    image: string
    description: string
    details: string[]
    category: ProductCategory
    capacityCoefficient: number
    priceCoefficient: number
}

export default ProductsSelection;